module.exports = __webpack_public_path__ + "img/hotdog.36ca8f04.png";